export default __webpack_public_path__ + "static/media/end-flow-tool.f46a572a.svg";